export default {
  seo: {
    title: "Inbraakschade reparatie Eindhoven | 24/7 spoedservice",
    description:
      "Inbraakschade aan uw raam, kozijn of deur ? Wij herstellen 24/7 met spoedservice, regelen verzekeringsdocumenten en plaatsen direct noodbeveiliging. Vanaf €95.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Inbraakschade",
  },
  hero: {
    banner: "Nu inbraakschade ? Bel direct : 06 38 27 20 35 — wij komen vandaag nog.",
    pill: "24/7 SPOEDSERVICE — EINDHOVEN",
    h1: "Inbraakschade reparatie in Eindhoven",
    subhead:
      "Inbraak gehad ? Uw woning is kwetsbaar. Wij staan binnen 2 uur voor uw deur en herstellen de schade dezelfde dag. Wij regelen de verzekering voor u.",
    usps: [
      "Binnen 2 uur ter plaatse",
      "24/7 ook 's nachts",
      "Werkt met uw verzekering",
      "Schadedossier door ons",
    ],
    ctaPhone: "Bel direct: 06 38 27 20 35",
    ctaForm: "Spoedformulier",
  },
  intro: {
    h2: "Wat doen na een inbraak ?",
    p1:
      "Een inbraak is schokkend. Naast onveiligheid heeft u praktische zorgen : woning niet afsluitbaar, verzekering inlichten, alles snel herstellen. Wij nemen die last over. Als specialist in inbraakschade herstellen eindhoven staan wij dag en nacht voor u klaar.",
    p2:
      "Onze monteurs rijden uit met volledig uitgeruste bestelwagen. Eerst noodbeveiliging — uw woning is binnen enkele uren weer afsluitbaar — daarna definitief herstel van inbraakschade raam, inbraakschade kozijn en deur geforceerd reparatie.",
    p3:
      "Tijdens het werk maken wij een schadedossier met foto's en bonnen voor uw verzekeraar. Vraag of u factuur op naam verzekering wenst — dat scheelt voorschieten. Ook bij spoedreparatie na inbraak en noodreparatie inbraak regelen wij alles.",
    p4:
      "Wij werken in alle wijken van Eindhoven en omgeving. Van Strijp tot Centrum, van Gestel tot Veldhoven — bij inbraakschade komen wij direct.",
  },
  directNaInbraak: {
    h2: "Direct na een inbraak — wat doen wij ?",
    steps: [
      {
        title: "Telefonisch contact binnen enkele minuten",
        text: "Bel 06 38 27 20 35. Wij nemen direct op, ook midden in de nacht. Wij beoordelen de situatie en geven direct advies over wat u nu moet doen.",
      },
      {
        title: "Spoeduitruk dezelfde dag, ook 's nachts en weekend",
        text: "Onze monteur komt binnen 2 uur naar u toe voor noodreparatie inbraak. Ook in het weekend en op feestdagen. U hoeft niet te wachten tot de volgende werkdag.",
      },
      {
        title: "Tijdelijke noodbeveiliging (dichttimmeren, noodslot)",
        text: "Uw woning moet vannacht afsluitbaar zijn. Wij plaatsen noodsloten, dichttimmeren gebroken ramen en zorgen dat u veilig kunt slapen. De volgende dag volgt definitief herstel.",
      },
      {
        title: "Definitief herstel kozijn / raam / deur / slot",
        text: "Na de eerste beveiliging herstellen wij alles definitief : nieuw glas, hersteld kozijn, vervangen slot met SKG-keurmerk, of een compleet nieuwe deur indien nodig.",
      },
      {
        title: "Verzekeringsrapport en fotodocumentatie",
        text: "Wij maken professionele foto's en een gedetailleerd rapport dat elke verzekeraar accepteert. Dit bespaart u weken aan administratie en zorgt voor snellere vergoeding.",
      },
    ],
  },
  stappenplan: {
    h2: "Stappenplan na een inbraak",
    steps: [
      { num: "01", title: "Bel politie", text: "112 of 0900-8844 voor aangifte" },
      { num: "02", title: "Bel ons", text: "06 38 27 20 35, binnen 2 uur" },
      { num: "03", title: "Wij beveiligen", text: "Noodbeveiliging deur/raam/slot" },
      { num: "04", title: "Wij herstellen", text: "Definitief + schadedossier" },
    ],
  },
  watWijHerstellen: {
    h2: "Inbraakschade die wij oplossen",
    rows: [
      {
        title: "Geforceerde voordeur",
        text: "Slot vaak geboord. Wij vervangen met SKG-keurmerk cilinder. Deur geforceerd reparatie is onze specialiteit. Wij herstellen ook beschadigd kozijn en deurpost.",
      },
      {
        title: "Gebroken ruit na inbraak",
        text: "Inbraakschade raam met gebroken glas ? Noodbeveiliging direct, nieuw glas in 48 uur. Wij werken met alle glaszetterijen in Eindhoven voor snelle levering.",
      },
      {
        title: "Beschadigd kozijn",
        text: "Inbraakschade kozijn met kapot beslag of sluitmechanisme ? Wij hebben originele onderdelen op voorraad. Kozijn herstel zonder wachttijden.",
      },
      {
        title: "Slot kapot of geboord",
        text: "SKG-vervanging verplicht voor verzekering. Wij plaatsen direct een anti-inbraak cilinder met SKG*** keurmerk. Ook bij poging tot inbraak adviseren wij vervanging.",
      },
      {
        title: "Schuifpui opengebroken",
        text: "Rollers, slot en beveiliging van uw schuifpui hersteld. Extra inbraakwering mogelijk. Wij plaatsen kierstandhouders en bijzetsloten voor meer veiligheid.",
      },
      {
        title: "Achterdeur of bijgebouw",
        text: "Volledige herstelling van achterdeur, garage of bijgebouw. Versterking met betonijzers en anti-inbraakbeslag voor extra veiligheid tegen herhaling.",
      },
    ],
  },
  verzekering: {
    h2: "Wij regelen uw verzekering",
    p1:
      "Een inbraak is al stressvol. Wij nemen het administratief werk over : onze monteurs maken ter plaatse een professioneel schadedossier met gedetailleerde foto's, bonnen en een schaderapport dat elke verzekeraar accepteert.",
    p2:
      "Wij werken samen met alle grote Nederlandse verzekeraars : Centraal Beheer, ABN AMRO, Aegon, Nationale-Nederlanden, Interpolis, ING, Univé en OHRA. Onze ervaring met inbraakschade herstellen eindhoven zorgt voor soepele afhandeling.",
    p3:
      "Vaak is directe afhandeling mogelijk. U geeft uw polisnummer door en wij regelen de rest. Vraag of u factuur op naam verzekering wenst — zo hoeft u niets voor te schieten. Wij maken het verzekeringsrapport gratis op.",
  },
  spoedInfo: {
    h2: "Hoe snel ter plaatse",
    cards: [
      { title: "Binnen 2 uur", text: "In Eindhoven en omstreken" },
      { title: "24/7 bereikbaar", text: "Ook 's nachts en weekend" },
      { title: "Mobiele werkplaats", text: "Alle materialen op voorraad" },
      { title: "Noodbeveiliging direct", text: "Meteen afsluitbaar" },
    ],
  },
  prijzen: {
    h2: "Kosten inbraakschade reparatie",
    note:
      "Wij maken het verzekeringsrapport gratis op. Vaak gedekt door inboedel- of opstalverzekering. Excl. 21% BTW.",
    rows: [
      { service: "Spoedmelding + diagnose", price: "Gratis", time: "30 min" },
      {
        service: "Noodbeveiliging / dichttimmeren",
        price: "Vanaf €95",
        time: "1-2 uur",
      },
      {
        service: "Slot vervangen na braak",
        price: "€85 - €175",
        time: "30-45 min",
      },
      {
        service: "Raam glas vervangen na inbraak",
        price: "Op offerte",
        time: "1-3 uur",
      },
      {
        service: "Kozijn / raam herstel",
        price: "Op basis offerte",
        time: "2-4 uur",
      },
      {
        service: "Volledig herstel voordeur",
        price: "Op offerte",
        time: "2-4 uur",
      },
      {
        service: "Schadedossier opstellen",
        price: "Inbegrepen",
        time: "-",
      },
    ],
  },
  beveiligingPreventie: {
    h2: "Beter beveiligd na de inbraak",
    intro:
      "Na een inbraak is het moment om uw woning beter te beveiligen. Wij geven gratis advies en plaatsen direct gecertificeerd hang- en sluitwerk. Zo voorkomt u dat inbrekers een tweede keer toeslaan.",
    items: [
      {
        title: "SKG-gecertificeerd hang- en sluitwerk",
        text: "Wij plaatsen sloten en beslag met SKG-keurmerk. Dit voldoet aan verzekeringseisen en biedt maximaal inbraakwerend vermogen. SKG** en SKG*** zijn de hoogste klassen.",
      },
      {
        title: "Anti-inbraak cilinders (SKG***)",
        text: "Een anti-inbraak cilinder met SKG*** keurmerk is bijna onmogelijk teforceren. Wij plaatsen deze direct na een inbraak, zodat uw nieuwe slot minstens zo sterk is als vereist.",
      },
      {
        title: "Kierstandhouders en bijzetsloten",
        text: "Extra beveiliging zonder duur te zijn. Kierstandhouders voorkomen dat de deur opengebroken wordt. Bijzetsloten op zowel voor- als achterdeur verdubbelen de weerstand.",
      },
      {
        title: "Advies inbraakpreventie",
        text: "Wij bekijken uw hele woning en geven advies op maat : betere verlichting, camera's, raambeveiliging en extra sloten. Een veiliger gevoel begint bij goede beveiliging.",
      },
    ],
    cta: "Bekijk onze cilinders →",
    ctaUrl: "/slot-cilinder-vervangen/",
  },
  waaromWij: {
    h2: "Waarom kiezen voor ons ?",
    reasons: [
      { num: "01", title: "24/7 spoedservice", text: "Ook 's nachts en weekend" },
      { num: "02", title: "Werkt met alle verzekeraars", text: "Directe afhandeling" },
      { num: "03", title: "SKG-gecertificeerd", text: "Verzekeringsconform" },
      { num: "04", title: "10 jaar schriftelijke garantie", text: "Op alle werkzaamheden" },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen over inbraakschade",
    items: [
      {
        q: "Hoe snel zijn jullie ter plaatse ?",
        a:
          "In Eindhoven en directe omgeving staan wij binnen 2 uur voor uw deur. Bel 06 38 27 20 35 — wij zijn 24/7 bereikbaar voor spoedreparatie na inbraak.",
      },
      {
        q: "Regelen jullie de verzekering ?",
        a:
          "Ja. Wij maken een professioneel schadedossier met foto's en bonnen. Wij werken met alle grote verzekeraars en kunnen de factuur rechtstreeks naar uw verzekering sturen. Wij maken het verzekeringsrapport gratis op.",
      },
      {
        q: "Moet ik eerst aangifte doen bij de politie ?",
        a:
          "Ja, politieaangifte is verplicht voor de verzekering. Bel 112 (spoed) of 0900-8844. Wij kunnen beginnen met beveiligen terwijl u aangifte doet.",
      },
      {
        q: "Kan ik de woning uit ?",
        a:
          "Dat is helaas niet altijd mogelijk. Onze eerste prioriteit is noodbeveiliging, zodat uw woning weer afsluitbaar is. Wij werken snel en discreet.",
      },
      {
        q: "Komen jullie ook 's nachts voor inbraakschade ?",
        a:
          "Ja, absoluut. Wij zijn 24 uur per dag, 7 dagen per week bereikbaar voor inbraakschade. Ook midden in de nacht komen wij direct voor noodbeveiliging en reparatie.",
      },
      {
        q: "Vergoedt mijn verzekering de inbraakschade ?",
        a:
          "In de meeste gevallen ja, via uw inboedel- of opstalverzekering. Wij maken een professioneel schadedossier dat elke verzekeraar accepteert. Vaak hoeft u niets voor te schieten.",
      },
      {
        q: "Hoe snel kunnen jullie noodbeveiliging plaatsen ?",
        a:
          "Noodbeveiliging plaatsen wij direct bij aankomst — binnen het eerste uur. Uw woning is dan weer afsluitbaar, zodat u veilig kunt slapen. Definitief herstel volgt dezelfde of volgende dag.",
      },
      {
        q: "Maken jullie een schaderapport voor de verzekeraar ?",
        a:
          "Ja, dat doen wij gratis. Wij maken professionele foto's van alle schade, een gedetailleerd rapport en overzichtelijke bonnen. Dit bespaart u weken aan administratie.",
      },
      {
        q: "Wat als ik geen verzekering heb ?",
        a:
          "Wij rekenen transparante prijzen. Noodbeveiliging vanaf €95, slotvervanging €85-€175. U ontvangt altijd een prijsopgave vooraf. Geen verborgen kosten.",
      },
      {
        q: "Wat bij een poging tot inbraak ?",
        a:
          "Ook bij poging tot inbraak adviseren wij vervanging van sloten. De verzekering vergoedt dit meestal. Wij maken het dossier en vervangen de cilinders met SKG-keurmerk.",
      },
    ],
  },
  interneLinks: {
    h2: "Gerelateerde diensten",
    cards: [
      {
        title: "Slotenmaker 24/7",
        url: "/slotenmaker-eindhoven/",
        text: "Buitengesloten of spoed ? Onze slotenmaker in Eindhoven is dag en nacht bereikbaar.",
      },
      {
        title: "Slot- en cilindervervanging",
        url: "/slot-cilinder-vervangen/",
        text: "Directe vervanging van defecte sloten en cilinders met SKG-keurmerk",
      },
      {
        title: "Glas vervangen",
        url: "/glas-vervangen/",
        text: "Gebroken ruit vervangen in 48 uur",
      },
      {
        title: "Kozijnreparatie",
        url: "/kozijn-reparatie/",
        text: "Vakkundig herstel van beschadigde kozijnen",
      },
      {
        title: "Draaikiepraam reparatie",
        url: "/draaikiepraam-reparatie/",
        text: "Reparatie en afstelling van draaikiepramen na inbraak",
      },
    ],
  },
  ctaBanner: {
    h2: "INBRAAK IN EINDHOVEN ? Bel NU : 06 38 27 20 35 — binnen 2 uur, 24/7.",
  },
  spoedForm: {
    h2: "Direct hulp nodig ? Meld spoed",
    steps: ["Wanneer", "Type schade", "Contact"],
    step1: {
      label: "Wanneer heeft u inbraak gehad ?",
      options: [
        "Vandaag",
        "Gisteren",
        "Eerder deze week",
        "Langer geleden",
      ],
    },
    step2: {
      label: "Welke schade is ontstaan ?",
      options: [
        "Voordeur geforceerd",
        "Raam gebroken",
        "Slot geboord",
        "Schuifpui beschadigd",
        "Kozijn beschadigd",
        "Anders",
      ],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoonnummer",
      address: "Adres",
      postcode: "Postcode",
      insurance: "Verzekeraar (optioneel)",
      insurancePlaceholder: "Bijv. Centraal Beheer",
      message: "Opmerkingen",
      messagePlaceholder: "Beschrijf de schade...",
      back: "Terug",
      next: "Volgende",
      submit: "Spoedmelding versturen",
    },
    success: {
      title: "Spoedmelding ontvangen",
      body: "Wij bellen u binnen 15 minuten terug.",
    },
  },
};